import React from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import DatePicker from 'components/DatePicker';
import TimePicker from 'components/TimePicker';
import Button from 'components/Button';
import { useMutation } from '@apollo/client';
import { UPDATE_BOOKING_BY_BOOKING_ID } from 'graphql/service';
import { TravelInputRow } from './styles';
import colors from 'constants/colors';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { message } from 'antd';

const TravelArrangements = ({ 
  disabled,
  customerStatus,
  bookingId,
  checkInDate,
  checkOutDate,
  setCheckInDate,
  setCheckOutDate,
}) => {

  const [updateBookingByBooingId, { loading }] = useMutation(UPDATE_BOOKING_BY_BOOKING_ID, {
    onCompleted: () => {
      message.success('Changes saved successfully')
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content);
      }
    }
  })

  const handleSaveChanges = () => {
    if(loading) return
    updateBookingByBooingId({
      variables: {
        bookingId,
        input: {
          checkInDate: checkInDate,
          checkOutDate: checkOutDate,
        }
      }
    })
  }
  
  return (
    <Card>
      <CardHeader>
        <div className='type'>TRAVEL ARRANGEMENTS</div>
      </CardHeader>
      <TravelInputRow>
        <div className='mobileRow'>
          <div className="datePickerContainer">
            <span>ARRIVAL</span>
            <DatePicker
              disabled={disabled || (customerStatus === 'CURRENT') || (customerStatus === 'PREVIOUS')}
              error={checkInDate? moment(checkInDate).tz(TIME_ZONE) >= moment(checkOutDate).tz(TIME_ZONE): false}
              minDate={moment(new Date()).tz(TIME_ZONE)}
              dateValue={moment(checkInDate).tz(TIME_ZONE)}
              dateOnChange={setCheckInDate}
              additionalstyle={`
                width: 100%;
                min-width: 130px;
                border: 1px solid ${colors.darkGrey};

                input {
                  padding-right: 26px;
                }

                ${disabled?`
                  border: none;

                  input {
                    padding-left: 0;
                  }
                  
                  button {
                    display: none;
                  }
                `: null}
              `}
            />
            <span className="datePlaceHolder">MM/DD/YYYY</span>
          </div>
          <div className="timePickerContainer">
            <span>ARRIVAL TIME</span>
            <TimePicker
              disabled={disabled || (customerStatus === 'CURRENT') || (customerStatus === 'PREVIOUS')}
              TimeValue={moment(checkInDate).tz(TIME_ZONE)}
              setTime={setCheckInDate}
              additionalstyle={`
                width: 100%;
                min-width: 110px;
                border: 1px solid ${colors.darkGrey};

                input {
                  padding-right: 26px;
                }

                ${disabled?`
                  border: none;

                  input {
                    padding-left: 0;
                  }

                  button {
                    display: none;
                  }
                `: null}
              `}
            />
            <span className="timePlaceHolder">HH:MM</span>
          </div>
        </div>
        <div className='mobileRow'>
          <div className="datePickerContainer">
            <span>DEPARTURE</span>
            <DatePicker
              disabled={disabled || (customerStatus === 'PREVIOUS')}
              error={checkInDate? moment(checkInDate).tz(TIME_ZONE) >= moment(checkOutDate).tz(TIME_ZONE): false}
              minDate={moment(new Date()).tz(TIME_ZONE)}
              dateValue={moment(checkOutDate).tz(TIME_ZONE)}
              dateOnChange={setCheckOutDate}
              additionalstyle={`
                width: 100%;
                min-width: 130px;
                border: 1px solid ${colors.darkGrey};

                input {
                  padding-right: 26px;
                }

                ${disabled?`
                  border: none;

                  input {
                    padding-left: 0;
                  }

                  button {
                    display: none;
                  }
                `: null}
              `}
            />
            <span className="datePlaceHolder">MM/DD/YYYY</span>
          </div>
          <div className="timePickerContainer">
            <span>DEPARTURE TIME</span>
            <TimePicker
              disabled={disabled || (customerStatus === 'PREVIOUS')}
              TimeValue={moment(checkOutDate).tz(TIME_ZONE)}
              setTime={setCheckOutDate}
              additionalstyle={`
                width: 100%;
                min-width: 110px;
                border: 1px solid ${colors.darkGrey};

                input {
                  padding-right: 26px;
                }

                ${disabled?`
                  border: none;

                  input {
                    padding-left: 0;
                  }

                  button {
                    display: none;
                  }
                `: null}
              `}
            />
            <span className="timePlaceHolder">HH:MM</span>
          </div>
        </div>
      </TravelInputRow>
      <div className='buttonContainer'>
        {!disabled?
          <Button
            mainPage
            success
            onClick={handleSaveChanges}
            data-loading={loading}
            additionalstyle={`
              width: 113px;
            `}
          >
            {loading? null: 'Save Changes'}
          </Button>: null
        }
      </div>
    </Card>
  );
};

export default TravelArrangements;
